export default __webpack_public_path__ + "static/media/phylactere_mes_freres.646d8cbc.png";